import { SectionHeader, ExportButton, ExportType } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { ExportCertificatesPdfRequestDto } from "~/gen/api"
import { useExportCertificatesPdfMutation } from "~/pages/Brand/Certificates/hooks/useExportCertificatesPdfMutation"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesTableHeaders = () => {
  const { t } = useTranslation("common")

  const { checkedCertificates } = useCertificatesTableContext()

  const { mutate: exportCertificates, isLoading: isCertificateExportLoading } =
    useExportCertificatesPdfMutation()

  return (
    <SectionHeader
      title="Certificates"
      mainCta={
        <ExportButton<ExportCertificatesPdfRequestDto>
          label={t("actionButtons.export")}
          exportOptions={[
            {
              type: ExportType.PDF,
              label: t("actionButtons.exportAsPdf"),
              isLoading: isCertificateExportLoading,
              exportFunction: (args) => exportCertificates(args),
              args: {
                certificateIds: Array.from(checkedCertificates),
              },
            },
          ]}
          count={checkedCertificates.size}
          disabled={checkedCertificates.size === 0}
        />
      }
    />
  )
}
